export default __webpack_public_path__ + "static/media/facings-logo-white.63204200.svg";